import state from './moduleHullInsuranceState.js'
import mutations from './moduleHullInsuranceMutations.js'
import actions from './moduleHullInsuranceActions.js'
import getters from './moduleHullInsuranceGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}
